import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled(Link)`
  text-decoration: none;
  position:relative;
  .coming-soon-image{
   scale:1.2;
   position:absolute;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  // background: var(--raffle-bg-color);
  background:#eaf0d5;
  border-radius: 10px;
  border: 1px solid var(--placeholder-color);
  border-image-source: var(--info-color);
  cursor: pointer;
  color: var(--primary-color);
    h1 {
    margin: 0.5rem 0 0 0 !important;
    // background: var(--placeholder-color);
    background: black;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 1.3rem !important;
    font-weight: 700;
    text-transform: capitalize;
  }
  .startDate{
    font-size: 1rem;
    // color: var(--placeholder-color);
    color: #8c9080;
  }
  .details{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .heart-icon-div{
    display: flex;
    align-items: center;
    justify-content:cenetr;
  }
  .heart-icon{
    color:black;
    font-size: 30px;
    cursor: pointer;
    &:hover{
      color: var(--primary-color);
    }
`;

export const Image = styled.img`
  width: 100%;
  aspect-ratio: 4 / 2;
  border-radius: 6px;
  object-fit: cover;
`;

export const Title = styled.h2`
  text-wrap: nowrap !important;
`;
export const Info = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-left: 4px;
  div {
    margin: 0;
    color: var(--placeholder-color);
    span {
      font-size: 12px;
      color: var(--placeholder-color);
      font-weight: 400;
    }
  }
  @media (max-width: 426px) {
    h2 {
      font-size: 12px;
      display: flex;
      span {
        font-size: 12px;
      }
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  height: 24px;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  h2 {
    background: #ffffff;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 14px;
    margin: 0;
    font-weight: 400;
    // color: ;
  }
  .waiting {
    -webkit-text-fill-color: #f9c74f;
  }
  button {
    background: none;
    border: none;
    padding: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 426px) {
    h2 {
      font-size: 12px;
    }
  }
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  font-size: 16px;
  margin-top: 8px;
  h1 {
    margin: 0px !important;
    background: var(--disabled-button-label-color);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 16px !important;
    font-weight: 700;
  }
  .play-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    gap:5px;
    width: 100%;
    height: 40px;
    background: var(--primary-color);
    border: none;
    border-radius: 6px;
    color: white; 
    font-size: 16px;
    font-weight: 600;
  }
  .game-controller{
    margin-bottom: 6px;
  }
`;
